import axios from "axios";
import { getPreviousDate } from "../components/utils/dateFormate";
import { formatDateToYYYYMMDD } from "../components/utils/formatDateToYYYYMMDD";

const API_URL = "https://clm-analytics.jagran.com/api/v1/cms/cdp/registration/get-filtered-count";
export const registerUserService = async (
    product_id,
  date = getPreviousDate(),
//   end_date = new Date(),
) => {
  const startDate = formatDateToYYYYMMDD(date);
  const endDate = formatDateToYYYYMMDD(date);

  if (!startDate || !endDate) {
    console.warn("Invalid date(s) provided. API call may fail.");
  }

  const data = {
    product_id: product_id,
    start_date: startDate,
    end_date: endDate,
  };

  
  
  try {
    const response = await axios.post(API_URL, data);

    return response.data;
  } catch (error) {
    console.error("Error fetching registration data:", error.response?.data || error.message);
    throw error; 
  }
};